import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import swal from "sweetalert2";     
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const AddPurchase = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;  
  const navigate = useNavigate();
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendorList, setVendorList] = useState([]);

  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
  const [groupedOptions, setGroupedOptions] = useState([]);

  const [optionsUnits, setOptionsUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);

  const [brand, setBrand] = useState("");
  const [quantity, setQuantity] = useState("");
  const [estimateCost, setEstimateCost] = useState("");

  const [rawMaterialsList, setRawMaterialsList] = useState([]);
  const [purchaseDate, setPurchaseDate] = useState(null);

  // Validation error states
  const [errors, setErrors] = useState({});

  const tableRef = useRef(null);

  const Group = (props) => (
    <div style={{ padding: "10px" }}>
      <components.Group {...props} />
    </div>
  );

  const customStyles = {
    groupHeading: (provided) => ({ 
      ...provided,
      fontSize: "14px",
      fontWeight: "bold",
      color: "#333",
    }),
  };

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10); 
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [vendors, setVendors] = useState([]); 
 
  useEffect(() => {
    const url = new URL(`${baseURL}/managevendor/vendors/active`);
    if (branch_id) {
      url.searchParams.append('branch_id', branch_id);
    }

    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        if (data.vendors) {
          setVendors(data.vendors);  // Save full vendor data
          const options = data.vendors.map((vendor) => ({
            value: vendor.sno,
            label: vendor.vendor_businessname,
          }));
          setVendorList(options);
        }
      })
      .catch((err) => console.error("Error fetching vendors:", err));
  }, [baseURL, branch_id]);

 
  const [staffOptions, setStaffOptions] = useState([]);

  const [show, setShow] = useState(true); // set according to your modal or page logic

useEffect(() => {
  if (show) {
    axios.get(`${baseURL}/active-staff`)
      .then(res => {
        const options = res.data.data.map(s => ({
          value: s.id,
          label: s.name
        }));
        setStaffOptions(options);
      })
      .catch(err => {
        console.error("Failed to fetch staff list", err);
      });
  }
}, [show]);
  const [assign, setAssign] = useState({
  staff: null
});

const handleStaffChange = (staff) => {
  setAssign(prev => ({ ...prev, staff }));
  setErrors(prev => ({ ...prev, staff: null })); // clear error on change
};

 


  // Fetch units by category sno = 4 on mount (default category)
  useEffect(() => {
    fetchUnitsByCategory(8, setOptionsUnits);
  }, [baseURL]);
 
  // Fetch units for selected raw material's category on change
  useEffect(() => {
    if (selectedRawMaterial && selectedRawMaterial.categorySno) {
      fetchUnitsByCategory(selectedRawMaterial.categorySno, setOptionsUnits);
      setSelectedUnit(null);
    }
  }, [selectedRawMaterial]);

  const fetchUnitsByCategory = async (categorySno, setOptions) => {
    try {
      const response = await axios.get(`${baseURL}/manageunit/by-category`, {
        params: { unit_category_sno: categorySno },
      });
      if (response.data.success) {
        const options = response.data.data.map((unit) => ({
          value: unit.unit_name,
          label: unit.unitslug_name,
        }));
        setOptions(options);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.error("Error fetching units by category:", error);
      setOptions([]);
    }
  };

 
  const handleRawMaterialChange = (selected) => {
    setSelectedRawMaterial(selected);
    setErrors((prev) => ({ ...prev, rawMaterial: null }));
  };
  const handleUnitChange = (selected) => {
    setSelectedUnit(selected);
    setErrors((prev) => ({ ...prev, unit: null }));
  };

 

  // Handle deleting raw material from list
  const handleDeleteRawMaterial = (index) => {
    setRawMaterialsList((prev) => prev.filter((_, i) => i !== index));
  };

  // DataTable init for table scrolling and styling
  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          responsive: true,
          ordering: false,
          paging: false,
          scrollY: "250px",
          scrollCollapse: true,
          language: {
            lengthMenu: "Show _MENU_",
          },
          dom:
            "<'row'" +
            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            ">",
        });
      }
    }
  }, [rawMaterialsList]);
 
  const handleCreatePurchase = async () => {
    let validationErrors = {};

    if (!selectedVendor) validationErrors.vendor = "Vendor is required";
    if (!assign.staff) validationErrors.staff = "Staff is required"; // <-- add staff validation
    if (!purchaseDate) validationErrors.purchaseDate = "Purchase date is required";
    if (rawMaterialsList.length === 0)
      validationErrors.rawMaterialsList = "Add at least one raw material";
 
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    const formattedDate =
      purchaseDate.format
        ? purchaseDate.format("YYYY-MM-DD")
        : purchaseDate;

    const payload = {
      vendor_id: selectedVendor.value,
      purchase_staff: assign.staff.value,
      purchase_date: formattedDate,
      created_by: user_id,      // add here
      branch_id: branch_id, 
      raw_material: rawMaterialsList.map((item) => ({
        raw_material_id: item.raw_material_id,
        raw_material_name: item.raw_material_name,
        brand: item.brand,
        quantity: item.quantity,
        unit_id: item.unit_id,
        per_unit_cost: item.per_unit_cost,
        // total_cost: item.total_cost,
      })),
    };
    console.log("Payload being sent:", JSON.stringify(payload, null, 2));
    try {
      const result = await swal.fire({
        title: "Are you sure?",
        text: "Do you want to create this purchase?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, create it!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        const response = await axios.post(`${baseURL}/purchases`, payload);

        if (response.data.success) {
          navigate('/manage-purchase', {
              state: { toastMessage: 'Purchase Created Successfully!', toastType: 'success' }
          });
        } else {
          navigate('/manage-purchase', {
              state: { toastMessage: 'Purchase Created Successfully!', toastType: 'success' }
          });
        }
      }
    } catch (error) {
      console.error("Error creating purchase:", error);
      navigate('/manage-purchase', {
          state: { toastMessage: 'Error Creating Purchase', toastType: 'error' }
      });
    }
  };

  const [isEditMode, setIsEditMode] = useState(false);
const [editIndex, setEditIndex] = useState(null);



const handleAddOrUpdateRawMaterial = () => { 
  if (!selectedRawMaterial) {
    setErrors(prev => ({ ...prev, rawMaterial: 'Please select raw material' }));
    return;
  }
  if (!quantity || isNaN(quantity) || Number(quantity) <= 0) {
    setErrors(prev => ({ ...prev, quantity: 'Enter valid quantity' }));
    return;
  }
  if (!selectedUnit) {
    setErrors(prev => ({ ...prev, unit: 'Please select unit' }));
    return;
  }
  if (!estimateCost || isNaN(estimateCost) || Number(estimateCost) < 0) {
    setErrors(prev => ({ ...prev, estimateCost: 'Enter valid cost' }));
    return;
  }

  const newItem = {
    raw_material_id: selectedRawMaterial.value,
    raw_material_name: selectedRawMaterial.label,
    brand: brand,
    quantity: Number(quantity),
    unit_id: selectedUnit.value,
    unit_label: selectedUnit.label,
    per_unit_cost: Number(estimateCost),
  };

  if (isEditMode && editIndex !== null) { 
    setRawMaterialsList(prevList => {
      const updatedList = [...prevList];
      updatedList[editIndex] = newItem;
      return updatedList;
    });
  } else { 
    setRawMaterialsList(prevList => [...prevList, newItem]);
  }
 
  setSelectedRawMaterial(null);
  setBrand('');
  setQuantity('');
  setSelectedUnit(null);
  setEstimateCost('');
  setErrors({});
  setIsEditMode(false);
  setEditIndex(null);
};
 

const handleEditRawMaterial = (index) => {
  const item = rawMaterialsList[index];
  setSelectedRawMaterial({ value: item.raw_material_id, label: item.raw_material_name });
  setBrand(item.brand || '');
  setQuantity(item.quantity.toString());
  setSelectedUnit({ value: item.unit_id, label: item.unit_label });
  setEstimateCost(item.per_unit_cost.toString());
  setIsEditMode(true);
  setEditIndex(index);
  setErrors({});
};

 const [totalEstimateCost, setTotalEstimateCost] = useState(0);
 
 

// const handleRawMaterialSelect = (selectedOption) => {
//   setSelectedRawMaterial(selectedOption);
 
//   const category = groupedOptions.find(group =>
//     group.options.some(opt => opt.value === selectedOption.value)
//   );
 
//   const fullMaterial = category?.options.find(opt => opt.value === selectedOption.value);

//   if (fullMaterial) {
//     const qty = Number(fullMaterial.rawmaterial_quantity || 0);
//     const cost = Number(fullMaterial.base_cost || 0);

//     setBrand(fullMaterial.brand_name || '');
//     setQuantity(qty);
//     setFetchedQuantity(qty);
//     setFetchedTotalCost(cost);
//     setEstimateCost(cost.toFixed(2));

//     setSelectedUnit({
//       value: fullMaterial.rawmaterial_unit,
//       label: fullMaterial.rawmaterial_unit_name,
//     }); 
//     // fetchUnitsByCategory(category.category_sno, setOptionsUnits);
    
//   }
// };

const handleRawMaterialSelect = async (selectedOption) => {
  setSelectedRawMaterial(selectedOption);

  const category = groupedOptions.find(group =>
    group.options.some(opt => opt.value === selectedOption.value)
  );

  const fullMaterial = category?.options.find(opt => opt.value === selectedOption.value);

  let latestPrice = null;

  // ---------------- FETCH PRICEBOOK -------------------
  try {
    const res = await fetch(`${baseURL}/raw-pricebook?vendor_id=${selectedVendor?.value}`);
    const result = await res.json();

    if (result?.data?.length > 0) {
      const priceItem = result.data.find(item => item.raw_material_id === selectedOption.value);

      if (priceItem && priceItem.prices) {
        const priceEntries = Object.entries(priceItem.prices);
        if (priceEntries.length > 0) {
          // Sort by date DESC to get latest
          priceEntries.sort((a, b) => new Date(b[0]) - new Date(a[0]));
          latestPrice = Number(priceEntries[0][1].per_amount); // per 1 qty
        }
      }
    }
  } catch (error) {
    console.log("Pricebook Fetch Error:", error);
  }

  // ---------------- SET UI FIELDS -------------------
  if (fullMaterial) {
    const qty = Number(fullMaterial.rawmaterial_quantity || 0);
    const baseCost = Number(fullMaterial.base_cost || 0);

    let finalCost = 0;

    // CASE 1 → Pricebook has per_amount → calculate final cost
    if (latestPrice !== null) {
      finalCost = latestPrice * qty;             // multiply by quantity
    } else {
      // CASE 2 → fallback to base cost
      finalCost = baseCost;
    }

    setBrand(fullMaterial.brand_name || '');
    setQuantity(qty);
    setFetchedQuantity(qty);
    setFetchedTotalCost(finalCost);
    setEstimateCost(finalCost.toFixed(2));

    setSelectedUnit({
      value: fullMaterial.rawmaterial_unit,
      label: fullMaterial.rawmaterial_unit_name,
    });
  }
};


const evaluateExpression = (expr) => {
  try {
    return Function(`"use strict"; return (${expr})`)();
  } catch {
    return 0;
  }
};
 
const [pendingMaterials, setPendingMaterials] = useState([]);
const [showPendingTable, setShowPendingTable] = useState(false);

useEffect(() => {
  const rawTotal = rawMaterialsList.reduce((sum, item) => {
    const cost = parseFloat(evaluateExpression(item.per_unit_cost)) || 0;
    const qty = parseFloat(item.quantity) || 0;
    return sum + cost;
  }, 0);

  const pendingTotal = pendingMaterials.flatMap(item => {
    let list = [];
    try {
      list = JSON.parse(item.purchased_list);
    } catch {
      list = [];
    }

    return list
      .filter(mat => mat.amount_status === "0")
      .map(mat => {
        const materialObj = groupedOptions
          .flatMap(group => group.options)
          .find(rm => rm.value === mat.raw_material_id);

        const costPerUnit = parseFloat(materialObj?.base_cost || mat.base_cost || 0);
        const quantity = parseFloat(mat.pending_quantity || 0);
        return costPerUnit;
      });
  }).reduce((sum, item) => sum + item, 0);

  setTotalEstimateCost(rawTotal + pendingTotal);
}, [rawMaterialsList, pendingMaterials, groupedOptions]);

 
const [perUnitCost, setPerUnitCost] = useState(0);
const [fetchedQuantity, setFetchedQuantity] = useState(0);
const [fetchedTotalCost, setFetchedTotalCost] = useState(0);

 

const handleVendorChange = async (selectedOption) => {
  setSelectedVendor(selectedOption);

  // 🟢 Group raw materials by category
  const vendor = vendors.find(v => v.sno === selectedOption.value);

  if (vendor && vendor.raw_materials) {
    const grouped = vendor.raw_materials.reduce((acc, material) => {
      const categoryName = material.rawmaterial_category_name || 'Others';
      const existingCategory = acc.find(cat => cat.label === categoryName);

      const option = {
        value: material.rawmaterial_id,
        label: material.rawmaterial_name,
        rawmaterial_quantity: material.rawmaterial_quantity,
        base_cost: material.base_cost,
        brand_name: material.brand_name,
        rawmaterial_unit: material.rawmaterial_unit,
        rawmaterial_unit_name: material.rawmaterial_unit_name,
      };

      if (existingCategory) {
        existingCategory.options.push(option);
      } else {
        acc.push({
          label: categoryName,
          options: [option],
          category_sno: material.rawmaterial_category_id || null,
        });
      }
      return acc;
    }, []);

    setGroupedOptions(grouped);
  } else {
    setGroupedOptions([]);
  }

  // Reset raw material selection on vendor change
  setSelectedRawMaterial(null);

  // 🟢 Fetch pending materials (status = 0)
  try {
    const branchId = branch_id; // change dynamically if needed
    const vendorId = selectedOption.value;

    const response = await axios.get(
      `${baseURL}/pending-materials/${branchId}/${vendorId}`
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      setPendingMaterials(response.data.data);
      setShowPendingTable(true);
    } else {
      setPendingMaterials([]);
      setShowPendingTable(false);
    }
  } catch (error) {
    console.error("Error fetching pending materials:", error);
    setPendingMaterials([]);
    setShowPendingTable(false);
  }
};

 

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
        <div className='mb-2'>
          <div className="mb-0 px-0">
            <h4 style={{ color: '#025d3a' }}>Add Purchase</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item">Package Management</li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active"><Link to='/manage-purchase'>Manage Purchase</Link></li>
          </ol>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-lg-3 mb-4">
          <label className="text-black font-w500 fs-7">
            Purchase Date<span className="required">*</span>
          </label>
          <div className='datepicker-wrapper d-flex'>
            <div className='input-group-text bg-transparent border-0 px-0'>
              <i className='fa-solid fa-calendar-days fs-4'></i>
            </div>
            <DatePicker
              placeholder='Select Date'
              value={purchaseDate}
              onChange={(date) => {
                setPurchaseDate(date);
                setErrors((prev) => ({ ...prev, purchaseDate: null }));
              }}
              format="DD-MM-YYYY"
            />
          </div>
          {errors.purchaseDate && <span className="text-danger fs-7">{errors.purchaseDate}</span>}
        </div>

        <div className="col-lg-3 mb-4">
          <label className="text-black font-w500 fs-7">
            Vendor<span className="required">*</span>
          </label> 
          <Select
            options={vendorList}
            onChange={handleVendorChange}
            value={selectedVendor}
            placeholder="Select Vendor"
          />

          {errors.vendor && <span className="text-danger fs-7">{errors.vendor}</span>}
        </div>
    <div className="col-lg-3 mb-4">
  <label className="text-black font-w500 fs-7">
    Staff<span className="required">*</span>
  </label>
  <Select
    placeholder="Select Staff"
    options={staffOptions} 
    onChange={handleStaffChange}
    value={assign.staff} 
  />
  {errors.staff && <span className="text-danger fs-7">{errors.staff}</span>}
</div>


      </div>

      <div className='card px-3 py-3 mb-6 border-success bg-success-light'>
        <div className='row'>
          <div className="col-lg-3 mb-4">
            <label className="text-black font-w500 fs-7">
              Raw Material<span className="required">*</span>
            </label>
            <Select
              options={groupedOptions}
              components={{ Group }}
              styles={{ groupHeading: customStyles.groupHeading }} 
              onChange={handleRawMaterialSelect} 
              value={selectedRawMaterial}
              placeholder="Select Raw Material"
            />
            {errors.rawMaterial && <span className="text-danger fs-7">{errors.rawMaterial}</span>}
          </div>

          <div className='col-lg-2'>
            <label className="text-black font-w500 fs-7">Brand</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Brand"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>

          <div className='col-lg-3 mb-4'>
            <div className='row'>
              <div className='col-lg-5'>
                <label className="text-black font-w500 fs-7">
                  Quantity<span className="required">*</span>
                </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Qty"
                    value={quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      setQuantity(value);
                      setErrors((prev) => ({ ...prev, quantity: null })); 
                      const newQty = parseFloat(value);
                      if (!isNaN(newQty) && fetchedQuantity > 0) {
                        const newCost = (newQty / fetchedQuantity) * fetchedTotalCost;
                        setEstimateCost(newCost.toFixed(2));
                      } else {
                        setEstimateCost('');
                      }
                    }}
                  />
 
                {errors.quantity && <span className="text-danger fs-7">{errors.quantity}</span>}
              </div>
              <div className='col-lg-7'>
                <label className="text-black font-w500 fs-7">
                  Units<span className="required">*</span>
                </label>
                <Select
                  options={optionsUnits}
                  onChange={handleUnitChange}
                  value={selectedUnit}
                  placeholder="Select Unit"
                />
                {errors.unit && <span className="text-danger fs-7">{errors.unit}</span>}
              </div>
            </div>
          </div>

          <div className='col-lg-2'>
            <label className="text-black font-w500 fs-7">
              Estimate Cost<span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Amount"
              value={estimateCost}
              onChange={(e) => {
                setEstimateCost(e.target.value);
                setErrors((prev) => ({ ...prev, estimateCost: null }));
              }}
              readOnly
            />
            {errors.estimateCost && <span className="text-danger fs-7">{errors.estimateCost}</span>}
          </div>

          <div className='col-lg-2 d-flex align-items-center'>
            <Button className="me-2" variant="primary" size='sm' onClick={handleAddOrUpdateRawMaterial}> 
              {isEditMode ? 'Update' : 'Add'}
            </Button>
           
            <Button
            className="me-2 text-white"
            variant="danger light"
            size="sm"
            onClick={() => {
              setSelectedRawMaterial(null);
              setBrand('');
              setQuantity('');
              setSelectedUnit(null);
              setEstimateCost('');
              setErrors({});
              setIsEditMode(false);
              setEditIndex(null);
            }}
          >
            Clear
          </Button>
          </div>
        </div>
        {errors.rawMaterialsList && (
              <div className="text-danger mt-2 fs-7 text-start pe-4">
                {errors.rawMaterialsList}
              </div>
            )}
      </div>
           
       <div className="table-container">
           
              <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                <thead>
                  <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                    <th className="min-w-100px">Raw Material</th>
                    <th className="min-w-100px">Brand</th>
                    <th className="min-w-50px">Qty / Units</th>
                    <th className="min-w-50px text-end">Estimate Cost</th>
                    <th className="min-w-50px text-end">Action</th>
                  </tr>
                </thead>
              

                <tbody className="text-gray-600 fw-semibold fs-7">
                  {[
                    ...rawMaterialsList,
                    ...pendingMaterials.flatMap(item => {
                      let list = [];
                      try {
                        list = JSON.parse(item.purchased_list);
                      } catch {
                        list = [];
                      }

                      // Only include pending items (amount_status === "0")
                      return list
                        .filter(mat => mat.amount_status === "0")
                        .map(mat => {
                          const materialObj = groupedOptions
                            .flatMap(group => group.options)
                            .find(rm => rm.value === mat.raw_material_id);

                          return {
                            ...mat,
                            raw_material_name: materialObj?.label || `ID: ${mat.raw_material_id}`,
                            unit_label: materialObj?.rawmaterial_unit_name || mat.unit_name || '-',
                            per_unit_cost: materialObj?.base_cost || mat.base_cost || 0,
                            isPending: true, // mark as pending
                          };
                        });
                    }),
                  ].map((item, idx) => {
                    // If item does not have isPending flag, it's editable
                    const isPending = item.isPending || false;

                    return (
                      <tr key={idx}>
                        <td>
                          <label className="text-black font-w400 fs-7">{item.raw_material_name}</label>
                        </td>
                        <td>
                          {item.brand && item.brand !== '' ? (
                            <label className="text-black font-w400 fs-7">{item.brand}</label>
                          ) : null}
                        </td>
                        <td>
                          <label className="text-black font-w400 fs-7">
                            {item.quantity || item.pending_quantity} {item.unit_label}
                          </label>
                        </td>
                        <td className="text-end">
                          <span className="badge bg-danger text-white fs-7 py-0 px-1">
                            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                            {evaluateExpression(item.per_unit_cost)}
                          </span>
                        </td>
                        <td className="text-end">
                          {!isPending && (
                            <span>
                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <span className="fs-8 text-white fw-semibold">Edit</span>
                                  </Tooltip>
                                }
                              >
                                <Link>
                                  <Button
                                    variant="primary tp-btn-light px-2 py-1 me-1"
                                    onClick={() => handleEditRawMaterial(idx)}
                                  >
                                    <i className="fa-solid fa-pen-to-square fs-6 mt-1"></i>
                                  </Button>
                                </Link>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <span className="fs-8 text-white fw-semibold">Delete</span>
                                  </Tooltip>
                                }
                              >
                                <Link>
                                  <Button
                                    variant="primary tp-btn-light px-2 py-1 me-1"
                                    onClick={() => handleDeleteRawMaterial(idx)}
                                  >
                                    <svg
                                      width="25px"
                                      height="25px"
                                      viewBox="0 -5 32 32"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="#025d3a"
                                    >
                                      <path d="M22.708,6.28c-0.394-0.39-1.032-0.39-1.427,0l-2.3,2.3-2.239-2.24c-0.39-0.39-1.024-0.39-1.415,0 
                                        c-0.391,0.39-0.391,1.03,0,1.42l2.239,2.23-2.268,2.27c-0.394,0.39-0.394,1.03,0,1.43c0.394,0.39,1.033,0.39,1.427,0 
                                        l2.268-2.26 2.239,2.24c0.391,0.39,1.025,0.39,1.415,0c0.391-0.4,0.391-1.04,0-1.43l-2.239-2.23 2.3-2.29
                                        C23.103,7.31,23.103,6.67,22.708,6.28zM29.998,17c0,1.1-0.896,2-2.002,2H10.467L2.316,9.98 10.438,1H27.996
                                        c1.106,0,2.002,0.9,2.002,2v14zM27.996,0H10.051c-0.28-0.02-0.566,0.07-0.78,0.28L0.285,10.22
                                        c-0.211,0.21-0.302,0.49-0.287,0.76c-0.015,0.28,0.076,0.56,0.287,0.77l9.986,9.94c0.196,0.19,0.452,0.28,0.708,0.28h18.017
                                        C30.207,22,32,20.21,32,18V4C32,1.79,30.207,0,27.996,0z"
                                      />
                                    </svg>
                                  </Button>
                                </Link>
                              </OverlayTrigger>
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan={2}></td>
                    <td className="text-end">
                      <label className="fs-5 fw-bold text-black">Total Estimated Cost</label>
                    </td>
                    <td className="text-end">
                      <label className="fs-5 fw-bold text-danger">
                        ₹ {totalEstimateCost.toFixed(2)}
                      </label>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
 

            {showPendingTable && pendingMaterials.length > 0 && (
              <div className="mt-5">
                <h5 className="text-success mb-3">Pending Materials for Selected Vendor</h5>
                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                  <thead>
                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                      <th className='min-w-50px'>S.No</th>
                      <th className='min-w-100px'>Purchase Date</th>
                      <th className='min-w-150px'>Raw Material</th> 
                      <th className='min-w-50px'>Quantity / Unit</th>  
                    </tr>
                  </thead>
                  <tbody className="text-gray-600 fw-semibold fs-7">
                    {pendingMaterials.map((item, index) => {
                      let list = [];
                      try {
                        list = JSON.parse(item.purchased_list);
                      } catch {
                        list = [];
                      }

                      return list
                        .filter(mat => mat.amount_status === "1") // only included
                        .map((mat, i) => {
                          // Find the raw material object to get name and unit
                          const materialObj = groupedOptions
                            .flatMap(group => group.options)
                            .find(rm => rm.value === mat.raw_material_id);

                          const rawMaterialName = materialObj?.label || `ID: ${mat.raw_material_id}`;
                          const unitName = materialObj?.rawmaterial_unit_name || mat.unit_name || '-';

                          return (
                            <tr key={`${index}-${i}`}>
                              <td className='text-black'><label className='text-black font-w600 fs-7'>{index + 1}</label></td>
                              <td><label className='text-black font-w600 fs-7'>{item.purchased_date}</label></td>
                              <td>
                                  <label className='text-black font-w600 fs-7'>
                                    {rawMaterialName}{(mat.brand) || ''}
                                  </label>
                                </td> 
                              <td className='text-black'><label className='text-black font-w600 fs-7'>{mat.pending_quantity} {unitName}</label></td> 
                            </tr>
                          );
                        });
                    })}
                  </tbody>
                </table>
              </div>
            )}
 
        </div>

        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <Link to={'/manage-purchase'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link> 
            <Button className="btn btn-sm btn-primary" onClick={handleCreatePurchase}  >
                Create Purchase
            </Button>
            
        </div>

    
      <style>
        {`
          .required {
            color: red;
            margin-left: 2px;
            font-weight: bold;
          }
          .datepicker-wrapper .rmdp-picker {
            width: 100%;
          }
          .text-danger {
            color: red;
            font-size: 0.85rem;
            margin-top: 2px;
            display: block;
          }
        `}
      </style>
    </>
  );
};

export default AddPurchase;
